import {Prop, Component, Vue} from "vue-property-decorator";
import {mixins} from "vue-class-component/lib/util";
import Sortable from "~/lib/sortable";
import iconCaretDown from '~/assets/inline-svg/icon_caret_down.svg?inline';
import type {SortableCurrentSort} from "~/lib/sortable";

@Component
export class DataTable extends mixins(Sortable) {

  @Prop({ required: true }) headers: any[];
  @Prop({ required: true }) tableData: any[];
  @Prop({ default: false }) selectable: boolean;
  @Prop({ default: () => [] }) selection: any[];
  @Prop({ default: (v) => v }) selectionIdentity: (v) => any;
  @Prop({ default: null }) rowRenderer: (v) => any;
  @Prop({ default: null }) rowClass: (v) => any;

  public currentSort: SortableCurrentSort = { key: 'id', type: 'number', order: 'desc' };

  renderCells(data) {

    const cellTds = this.headers.reduce((acc, header) => {
      acc.push(<td class={header.className}>{typeof header.value === "function" ? header.value(data) : data[header.value]}</td>);
      return acc;
    }, []);

    if (this.$scopedSlots.actions) {
      cellTds.push(<td class="action-col">{this.$scopedSlots.actions(data)}</td>);
    }

    return cellTds;
  }

  handleClickRow(rowData) {
    this.$emit("clickRow", rowData);
  }

  handleSelect(e, item) {
    e.stopPropagation();
    this.$emit("select", item);
  }

  get displayData() {
    return this.sort(this.tableData);
  }

  render() {
    return (
      <table class="data-table">
        <thead>
        <tr>

          {this.selectable && <th><input type="checkbox" checked={this.selection.length === this.tableData.length} onClick={e => this.handleSelect(e, null)} /></th>}

          {this.headers.map((header) => {
            if (!header.key) {
              return (<th class={header.className}>{header.label}</th>)
            }

            return (<SortableTH class={header.className} property={header.key} label={header.label} currentSort={this.currentSort} onSort={this.setCurrentSort} type={header.type || 'string'} />)
          })}

          {this.$scopedSlots.actions && <th class="action-col" />}

        </tr>
        </thead>

        <tbody>
        {
          this.displayData.map(item => typeof this.rowRenderer === "function" ?

            this.rowRenderer(item) :

            <tr class={`${typeof this.rowClass === "function" ? this.rowClass(item) : ""} `} onClick={() => this.handleClickRow(item)}>

              {this.selectable && (
                <td>
                  <input
                    type="checkbox"
                    checked={this.selection.some(iter => this.selectionIdentity(iter) === this.selectionIdentity(item))}
                    onClick={e => this.handleSelect(e, item)}
                  />
                </td>
              )}

              {this.renderCells(item)}

            </tr>)
        }
        </tbody>
      </table>
    );
  }
}


@Component
class SortableTH extends Vue {

  @Prop({ type: String, required: true }) property:string;
  @Prop({ type: String, required: true }) label:string;
  @Prop({ type: Object, required: true }) currentSort:SortableCurrentSort;
  @Prop({ type: [String, Function], default: "string" }) type:string |Function;

  render() {

    let className = "sortable";

    if (this.currentSort.key === this.property) {
      className += ` sorting-${this.currentSort.order}`;
    }

    return (
      <th class={className} onClick={() => this.$emit("sort", this.property, this.type)}>
        <div class={"sortable-label"}>{this.label}</div>
        <span class="icon">
          <i domPropsInnerHTML={iconCaretDown} />
        </span>
      </th>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-07d695d2/data-table.tsx" });